export function getDisplayTextForDurationLength(durationMinimum, durationMaximum) {
    const isLongAppointment = durationMaximum >= 120;
    const isDurationRange = durationMinimum !== durationMaximum;

    const adjustedMinimum = isLongAppointment ? durationMinimum / 60 : durationMinimum;
    const adjustedMaximum = isLongAppointment ? durationMaximum / 60 : durationMaximum;

    const durationText = isDurationRange
        ? `${adjustedMinimum} - ${adjustedMaximum}`
        : adjustedMinimum;

    const unitText = isLongAppointment ? "hours" : "minutes";

    return `${durationText} ${unitText}`;
}
